"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FocusManagerExample = void 0;
var tslib_1 = require("tslib");
var mithril_1 = tslib_1.__importDefault(require("mithril"));
var _1 = require("@/");
var examples_1 = require("@shared/examples");
var EXAMPLE_SRC = 'utils/focus-manager/examples/index.ts';
var FocusManagerExample = /** @class */ (function () {
    function FocusManagerExample() {
        this.showFocusOnTab = true;
    }
    FocusManagerExample.prototype.onremove = function () {
        _1.FocusManager.showFocusOnlyOnTab();
    };
    FocusManagerExample.prototype.view = function () {
        return (0, mithril_1.default)(examples_1.Example, { options: this.renderOptions(), direction: 'column', src: EXAMPLE_SRC }, [
            (0, mithril_1.default)(_1.Button, { label: 'Button', style: 'margin-bottom: 20px' }),
            (0, mithril_1.default)(_1.Input, { placeholder: 'Placeholder...' })
        ]);
    };
    FocusManagerExample.prototype.renderOptions = function () {
        var _this = this;
        return [
            (0, mithril_1.default)(_1.Switch, {
                checked: this.showFocusOnTab,
                label: 'Show focus only on tab',
                onchange: function () {
                    _this.showFocusOnTab
                        ? _1.FocusManager.alwaysShowFocus()
                        : _1.FocusManager.showFocusOnlyOnTab();
                    _this.showFocusOnTab = !_this.showFocusOnTab;
                }
            })
        ];
    };
    return FocusManagerExample;
}());
exports.FocusManagerExample = FocusManagerExample;
